<template>
  <div>

    <vs-table :data="data">
      <template slot="header">
                <div>
                  <export-button :data="filter" :url="'payroll/table/export/Pogh275275skguTkihSJF8976SHY'"/>
                </div>
                <div class="con-input-search vs-table--search">
                  <input
                    class="input-search vs-table--search-input"
                    type="text"
                    v-model="text"
                    @keypress.enter="search"
                  />
                  <vs-icon icon="search"></vs-icon>
                </div>
                <vs-button
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-filter"
                  class="mx-2"
                  radius
                  @click="openFilter"
                >
                </vs-button>
      </template>
      <template slot="thead">
        <th class="qb-sticky" :style="{background:'white'}"></th>
        <th-sort
          :text="$t('client')"
          column="Cl.ShortName"
          @sort="handleClickSort"
        />
        <th-sort
          :text="$t('week')"
          column="payrolls.PeriodId"
          @sort="handleClickSort"
        />
        <!-- //payroll_no -->
        <th-sort
          text="HCount"
          column="payrolls.headcount"
          @sort="handleClickSort"
        />
        <th class="qb-sticky">
          {{$t('hours')}}
        </th>
        <!-- <th-sort
          :text="$t('hours')"
          column="Cl.ShortName"
          @sort="handleClickSort"
        /> -->
        <th-sort
          class="text-center"
          :text="$t('total')"
          column="payrolls.total"
          @sort="handleClickSort"
        />
        <th-sort
          class="text-center"
          :text="$t('updated')"
          column="payrolls.updated_at"
          @sort="handleClickSort"
        />
        <!-- <th class="qb-sticky">
          {{ $t('updated') }}
        </th> -->
        <th class="qb-sticky">
          {{ $t('actions') }}
        </th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="i" v-for="(tr, i) in data">
          <vs-td>
            <vx-tooltip
              :text="`${(data[i].InvoiceId == null && data[i].plant_no == 0) ? $t('new') : ''}`"
               v-if="data[i].InvoiceId == null && data[i].plant_no == 0"
            >
              <span
                class="material-icons sm"
                :style="{
                  fontSize: '8px',
                  color: '#28C76F',
                }"
              >
                lens
              </span>
            </vx-tooltip>

            <vx-tooltip v-else text="En paquete">
              <span
                class="material-icons sm"
                :style="{
                  fontSize: '8px',
                  color: '#2858c7',
                }"
              >
                lens
              </span>
            </vx-tooltip>
          </vs-td>
          <vs-td>
             {{ data[i].client_name }}
          </vs-td>
          <vs-td> {{ data[i].Year }}-{{data[i].Week}} </vs-td>
          <vs-td class="text-left">
            {{ formatNumber(data[i].headcount, 2) }}
          </vs-td>
          <vs-td>
            {{
              formatNumber(
                Number(data[i].regular_hours) + Number(data[i].overtime),
                2
              )
            }}
          </vs-td>
          <vs-td class="text-right">
            $ {{ formatNumber(data[i].total, 2) }}
          </vs-td>
          <vs-td>
            {{ formatDate(data[i].updated_at) }}
          </vs-td>

          <vs-td>
            <div>
              <action-icon icon="FileIcon" :tooltip="$t('file')" @click="showPdf(data[i])"/>
            </div>
            <div>
              <export-action icon="ExternalLinkIcon" tooltip="Export to Excel"  type="payroll-detailed" 
                :data="report = {
                  client_id : data[i].client_id,
                  period_id : data[i].PeriodId
                }"/>
            </div>
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import ActionPdfViewer from '@/views/components/actions/ActionPdfViewer'
import mixins from '@/mixins'
import ExportAction from '@/views/components/actions/ExportAction.vue'
import ExportButton from '@/views/components/ExportButton.vue'

export default {
  components: {
    ActionIcon,
    ThSort,
    ExportButton,
    ExportAction,
    ActionPdfViewer
  },
  data: () => ({
    text: '',
  }),
  methods: {
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    search() {
      this.$emit('search', this.text)
    },
    handleClickSort(e) {
      this.$emit('sort', e)
    },
    openFilter() {
      this.$store.dispatch('toggleSidebar', 'payroll-filter')
    },
    showPdf(data){
      //console.log(data);
      this.$emit('showPdf',data)
    }
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    filter: {
      type: Object,
      default: () => ({
        client_id: [],
        status_id: [],
        start_week: '',
        end_week: '',
        sortBy: ['p.PeriodId', 'payrolls.InvoiceId', 'payroll_no'],
        sort: ['DESC', 'ASC', 'ASC'],
        new_registers: true
      }),
    },
  },
}
</script>

<style>
</style>
